module.exports = __webpack_public_path__ + "static/img/Orion Logo Text.b44e24b3.svg";